export class ReprocessResponseModel {
  message!: string;

  successCount!: number;

  failureCount!: number;

  reprocessLogId!: number;
}
